<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>

    <form class = "card-form"  [formGroup]="motorForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
        <div class="blue-top"></div>
        <div class="card-section top-section">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{LanguagePack.benefitsHeading}}</h2>
            <h3>{{LanguagePack.benefitsSubheading}}</h3>

            <mat-checkbox formControlName="excessProtector">
                <p class="checkbox-p" [innerHTML]="LanguagePack.protectorBenText | dompurify"></p>
            </mat-checkbox>
            <mat-checkbox formControlName="politicalViolence">
                <p class="checkbox-p" [innerHTML]="LanguagePack.politicalBenText | dompurify"></p>
            </mat-checkbox>
            <mat-checkbox formControlName="lossUse" *ngIf="insurance === 'private'">
                <p class="checkbox-p" [innerHTML]="LanguagePack.lossUseBenText | dompurify"></p>
            </mat-checkbox>

            <mat-checkbox formControlName="windscreen" (change)="clearWindscreenVal()" *ngIf="insurance !== 'motorcycle'">
                <p class="checkbox-p" [innerHTML]="LanguagePack.windBenText | dompurify"></p>
            </mat-checkbox>

            <div class="width-100pc" *ngIf="motorForm.controls['windscreen'].value === true">
                <mat-form-field appearance="outline" class="form-select">
                    <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.windscreenAmountLabel}}</mat-label>
                    <input matInput spellcheck="false" formControlName="windscreenAmount" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['windscreenAmount']">{{formErrors['windscreenAmount']}}</mat-error>
                </mat-form-field>
            </div>

            <mat-checkbox formControlName="entertainment" (change)="clearEntertainmentVal()" *ngIf="insurance === 'private' ||insurance === 'commercial'">
                <p class="checkbox-p" [innerHTML]="LanguagePack.entBenText | dompurify"></p>
            </mat-checkbox>

            <div class="width-100pc" *ngIf="motorForm.controls['entertainment'].value === true">
                <mat-form-field appearance="outline" class="form-select">
                    <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.entertainmentAmountLabel}}</mat-label>
                    <input spellcheck="false" matInput formControlName="entertainmentAmount" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['entertainmentAmount']">{{formErrors['entertainmentAmount']}}</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="form-select" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{LanguagePack.coverStartDateLabel}}</mat-label>
                <mat-hint>{{LanguagePack.coverStartDateDesc}}</mat-hint>
                <input matInput [min]="minCoverDate" [max]="maxCoverDate" (blur)="logErrors()" [matDatepicker]="coverPicker" readonly="true" (click)="coverPicker.open()" formControlName="coverStartDate">
                <mat-error *ngIf="formErrors['coverStartDate']">{{formErrors['coverStartDate']}}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="coverPicker"></mat-datepicker-toggle>
                <mat-datepicker #coverPicker></mat-datepicker>
            </mat-form-field>

            <div class="row-div margin-top-50 margin-bottom-30">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{LanguagePack.cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorForm.valid">
                    <span class="button-text">{{LanguagePack.saveContinue}}</span>
                </button>
            </div>
        </div>
    </form>
</div>
